import LWElement from './../../lib/lw-element.js';
import ast from './ast.js';

customElements.define('web-root',
  class extends LWElement {  // LWElement extends HTMLElement
    loggedIn = !!sessionStorage.getItem('session');

    constructor() {
      super(ast);
    }

    onLogin() {
      this.loggedIn = true;
      this.update();
      this.querySelector('web-dashboard')?.initSession();
    }

    onLogout(event) {
      this.loggedIn = false;
      setTimeout(() => {
        const login = this.querySelector('web-login');
        if (login) {
          login.reset();
          if (event?.detail?.expired) {
            login.setMessage('Your session has expired. Please sign in again.', 'danger');
          }
          login.update();
        }
        login?.querySelector('input[type="email"]')?.focus();
      });
    }
  }
);
